import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=e8ca6550&scoped=true&"
import script from "./Featured.vue?vue&type=script&lang=ts&"
export * from "./Featured.vue?vue&type=script&lang=ts&"
import style0 from "./Featured.vue?vue&type=style&index=0&id=e8ca6550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ca6550",
  null
  
)

export default component.exports